// 西班牙
const es = {
  描述: "Descripciones",
  图片: "Fotografía",
  名称: "Nombre",
  产品编码: "Código del Producto",
  总数: "Agregado",
  件数: "Recuento de Artículos",
  home: "Página de Inicio",
  用户账号: "Correo electrónico",
  昵称: "Usuario",
  product: "Productos",
  产品分类: "Productos",
  新商品: "Nuevos Productos",
  降价产品: "Productos con Descuento",
  全部分类: "Clasificación",
  返回首页: "Volver A La Página De Inicio",
  注册: "Registrarse",
  我的账户: "Mi Cuenta",
  我的采购单: "Mis Pedidos",
  // 欢迎光临舱多保产品库: 'Bienvenido al Catálogo de Productos de Hongxu',
  欢迎光临舱多保产品库:
    "Bienvenido A La Biblioteca De Productos De Hatch Turbine",
  你好请登录: "Hola, Iniciar Sesión",
  请输入您想要搜索的内容: "Introduzca Lo Que Desea Buscar",
  login: "Hola, Por Favor Inicie Sesión",
  search: "Búsqueda",
  exit: "Cerrar Sesión",
  爆款推荐: "Destacados",
  新产品: "Nuevos Productos",
  降价产品: "Productos con Descuento",
  // 人付款: 'Persona + Pago',
  人付款: "Sets",
  加入购物车: "Añadir al Carrito",
  登录: "Inicia Sesión",
  收藏夹: "Mis favoritos",
  个人中心: "Mi cuenta",
  首页: "En La Primera Página",
  价格筛选: "Precio",
  更多: "Más",
  由高到低: "De Mayor a Menor",
  由低到高: "De Menor a Mayor",
  上一页: "<  Anterior",
  下一页: "Siguiente  >",
  爆款: "Destacado",
  产品编码: "Código",
  装箱数: "Unidades",
  每箱体积: "Volumen Por Caja",
  每箱重量: "Peso Por Caja",
  分类: "Clasificación",
  最小起订箱: "MOQ",
  数量: "Cantidad",
  箱: "Caja",
  加入常购清单: "Lista De Compras",
  // 收藏: 'Agregar a favoritos',
  收藏: "Guardar en Favoritos",
  订单中心: "Centro de Pedidos",
  // 我的采购单: 'Mi orden de compra',
  常购清单: "Lista De Compras Habituales",
  账户管理: "Configuración de la Cuenta",
  个人信息: "Información Personal",
  收货地址: "Dirección de Entrega",
  修改密码: "Modificar La Contraseña",
  我的留言: "Buzón de Mensajes",
  申请开店: "Solicitar Apertura de una Tienda",
  全部: "Todo",
  修改个人信息: "Modificar La Información Personal >",
  请输入订单编号: "Por Favor Introduzca El Número De Pedido",
  商品: "Productos",
  单价: "Precio Unitario",
  数量: "Cantidad",
  操作: "Modificar Pedido",
  订单号: "Número de Pedido",
  订单状态: "Estado",
  已下单: "Pedidos realizado",
  处理中: "Encurso",
  已发货: "Enviado",
  已完成: "Completado",
  已取消: "Cancelado",
  订单取消: "Cancelado",
  已提交: "Ha Sido Presentado",
  下单时间: "Fecha",
  支付状态: "Pago",
  待支付: "Pendiente",
  已支付: "Pagado",
  交易成功: "Transacción realizada con éxito",
  物流运输中: "Logística Transporte En",
  订单详情: "Detalles del Pedido",
  取消: "Cancelar",
  确认收货: "Confirmación",
  订单完成: "Completado",
  订单总额: "Precio Total",
  打印: "Imprimir",
  导出: "Exporta",
  下载: "Descargar",
  配送地址: "Dirección De Entrega",
  收货地址: "Dirección De Entrega",
  姓名: "Nombre",
  电话号码: "Teléfono",
  公司名称: "Razón Social",
  邮政编码: "Código Postal",
  详细地址: "Dirección",
  配送: "Distribución",
  配送方式: "Formas De Entrega",
  货运信息: "Información Sobre Transporte",
  船运: "Transporte Marítimo",
  空运: "Transporte Aéreo",
  付款方式: "Formas De Pago",
  支付信息: "Información De Pago",
  收款公司: "Empresa De Cobro",
  收款账号: "Número De Cuenta",
  收款银行: "Banco Receptor",
  公司地址: "Dirección De Empresa",
  银行地址: "Dirección Del Banco",
  付款凭证: "Comprobante De Pago",
  商品清单: "Lista De Bienes",
  商品图片: "Imagen",
  商品编码: "Código",
  商品名称: "Nombre",
  箱数: "N° Piezas",
  体积: "Volumen",
  重量: "Peso",
  金额: "Importe",
  总重量: "Peso Total",
  总体积: "Volumen Total",
  总金额: "Precio Total",
  全选: "Seleccionar todos",
  删除: "Borrar",
  批量管理: "Gestión Por Lotes",
  导入常购清单: "Importar Lista De Compra Frecuente",
  性别: "Género",
  男: "Masculino",
  女: "Femenino",
  保密: "No especificar",
  出生日期: "Fecha de Nacimiento",
  选择日期: "Seleccione Una Fecha",
  头像: "Logo",
  邮箱: "Correo",
  个性签名: "Descripción",
  保存: "Guardar",
  您已创建: "Tiene",
  个收货地址: "direcciones de entrega",
  最多可创建: "máximo",
  个: "",
  新增收货地址: "Agregar",
  手机号码: "Fax",
  地址: "Dirección",
  编辑: "Editar",
  所在地区: "Su Región",
  请选择: "Seleccione",
  修改密码: "Cambiar mi Contraseña",
  当前密码: "Contraseña Actual",
  新密码: "Nueva Contraseña",
  确认密码: "Confirmar Nueva Contraseña",
  日期: "Fecha",
  回复: "Respuesta",
  留言: "Mensaje",
  请输入内容: "Por Favor Ingrese El Contenido",
  提交: "Enviar",
  联系人: "Contacto",
  联系电话: "Teléfono",
  手机号码: "Celular",
  申请入驻: "Enviar Solicitud",
  购物车: "Mi Carrito",
  全部: "Todos",
  // 件: 'Algo',
  件: "",

  已选择: "Seleccionado",
  移入收藏夹: "Ir a Favoritos",
  去付款: "Pagar",
  结账: "Facturación",
  选择收货地址: "Seleccione Una Dirección De Envío",
  管理收货地址: "Gestión De Direcciones De Envío",
  选择配送方式: "Elige Tu Método De Entrega",
  支付信息: "Información De Pago",
  确认: "Confirmación",
  留言管理: "Gestionar Buzón de Mensajes",
  标题: "Asunto",
  留言内容: "Contenido",
  请输入用户名: "Nombre De Usuario",
  请输入密码: "La Contraseña",
  忘记密码: "Olvidé mi contraseña",
  记住我: "Recordar contraseña",
  进入官网: "Acceso A La Web Oficial",
  请正确输入邮箱: "Por Favor Ingrese Su Correo Electrónico Correctamente",
  密码必须是的非空字符: "La Contraseña Debe Ser De 6-18 Caracteres No Nulos",
  找回密码: "Recupera Tu Contraseña",
  输入请您的邮箱: "Introduzca Por Favor Su Email",
  请输入注册邮箱: "Por Favor Ingrese Su Correo Electrónico Registrado",
  下一步: "Siguiente Paso",
  请正确输入邮箱: "Por Favor Ingrese Su Correo Electrónico Correctamente",
  验证信息: "Verificar La Información",
  设置新密码: "Una Nueva Contraseña",
  重置成功: "Restablecimiento Exitoso",
  验证码已发送至: "Enviado A",
  请输入邮箱内验证码进行重置密码: "Introduzca El Código De Verificación",
  请输入验证码: "Por Favor Introduzca El Captcha",
  发送验证码: "Enviar",
  重新发送: "El",
  验证码不能为空: "El Captcha No Puede Estar Vacío",
  两次输入的密码不一致: "Las Contraseñas Introducidas Dos Veces No Coinciden",
  请再次输入密码: "Por Favor, Introduzca La Contraseña De Nuevo",
  恭喜您密码重置成功快去登录吧:
    "Felicidades Tu Contraseña Ha Sido Restablecida Correctamente. Ve A Iniciar Sesión Ahora",
  登陆: "Inicio",
  商品详情: "Descripción del Especificaciones",
  推荐商品: "Recomendados",
  成功加入收藏夹: "Añadido A Favoritos Con éxito",
  成功加入常购清单: "Añadido Con éxito La Lista Compra Frecuente",
  添加成功: "Añadido Con éxito",
  您还未登录即将跳转登录页面:
    "Usted No Se Ha Identificado Pronto Saltar A La Página De Acceso",
  请选择商品再结算: "Por Favor Seleccione La Mercancía Para Reliquidar",
  下单成功: "Pedido Realizado Con éxito",
  请输入留言标题: "Por Favor Ingrese Título Del Mensaje",
  请输入留言内容: "Por Favor Ingrese El Mensaje",
  提交成功: "Enviado Con éxito",
  修改成功: "Modificado Con éxito",
  密码修改成功即将重新登录:
    "Contraseña Cambiada Con éxito Volver Iniciar Sesión Pronto",
  请检查当前密码输入是否正确:
    "Compruebe Que La Contraseña Actual Haya Sido Introducida Correctamente",
  回复成功: "Responder Con éxito",
  请输入回复内容: "Por Favor, Introduzca Una Respuesta",
  上传头像图片只能是JPGJPEGPNG格式:
    "Subir La Imagen De Avatar Solo Puede Ser En Formato JPG、JPEG、PNG!",
  上传头像图片大小不能超过2MB: "Subir Foto De Perfil No Debe Exceder 2MB",
  请输入姓名: "Por Favor Ingrese Su Nombre",
  请输入出生年月日: "Por Favor Ingrese Fecha Nacimiento Mes",
  请上传头像: "Por Favor Sube Avatar",
  请输入公司名称: "Por Favor Ingrese El Nombre De La Empresa",
  请输入电话号码: "Por Favor Ingrese Su Número De Teléfono",
  请输入个性签名: "Por Favor, Introduzca Una Firma De Personalidad",
  请选择性别: "Por Favor Seleccione Sexo",
  请输入邮箱: "Por Favor Ingrese Su Email",
  个人信息保存成功: "Información Personal Guardada Con éxito",
  您的入驻申请通过: "Su Solicitud De Admisión Través De",
  您的入驻申请正在审核中: "Su Solicitud De Admisión Está Siendo Revisada",
  您的入驻申请未通过未通过的原因为:
    "Su Solicitud De Admisión No Fue Aprobada Por La Razón De La Falta De Aprobación Es",
  请输入手机号码: "Por Favor Ingrese Su Número De Móvil",
  请输入联系电话: "Por Favor Ingrese Un Número De Contacto",
  请输入联系人: "Por Favor Ingrese Un Contacto",
  您的开店申请以提交请等待审核:
    "Su Solicitud De Apertura De Tienda Para Enviar Por Favor Espere La Revisión",
  邮箱注册: "Registro De Buzón",
  微信: "Whatsapp",
  电话: "Teléfono",
  回顶部: "Top",
  打开微信: "Abrir Whatsapp",
  扫码添加客服: "Escanear Código QR",
  综合: "Integrado",
  销量: "Ventas",
  新品: "XinPin",
  价格: "Precio",
  更多: "Más",
  请上传文件材料: "Cargue La Documentación",
  舱多保供应链版权所有:
    "Derechos De Autor De La Cadena De Suministro De Cabinduobao Todos Los Derechos De Autor",
  您的订单已经处理成功订单号:
    "Su Pedido Se Ha Procesado Con éxito El Número De Pedido",
  查看订单: "Ver Orden",
  导入购物车: "Cesta De Importación",
  MOQ: "MOQ: ",
  SetS: "SetS",
  销量筛选: "Filtro De Ventas",
  共有: "Total",
  转到购物车: "Ir a Mi Carrito",
  生成采购单: "Generar Pedido",
  暂无发货清单: "No Hay Lista De Envío",
  发货清单: "Hay Lista De Envío",
  导出Excel: "Exportar Excel",
  符号: "$",
  // 产品分类
  language: {
    zh: "中文",
    en: "English",
    es: "Español",
    por: "Português",
  },
};
export default es;
